/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Frauen_Karriereplanung32Inputs */

const en__field_enum_csjensblank_frauen_karriereplanung32 = /** @type {(inputs: _Field_Enum_Csjensblank_Frauen_Karriereplanung32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`carrer options for woman`)
};

const de__field_enum_csjensblank_frauen_karriereplanung32 = /** @type {(inputs: _Field_Enum_Csjensblank_Frauen_Karriereplanung32Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frauen Karriereplanung`)
};

/**
* | output |
* | --- |
* | "carrer options for woman" |
*
* @param {_Field_Enum_Csjensblank_Frauen_Karriereplanung32Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_frauen_karriereplanung32 = /** @type {((inputs?: _Field_Enum_Csjensblank_Frauen_Karriereplanung32Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Frauen_Karriereplanung32Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_frauen_karriereplanung32(inputs)
	return de__field_enum_csjensblank_frauen_karriereplanung32(inputs)
});
export { _field_enum_csjensblank_frauen_karriereplanung32 as "_field_enum_CSJENSBLANK_FRAUEN_KARRIEREPLANUNG" }